import {Component, Input, OnChanges} from '@angular/core';
import {RotaAssignment} from '../../../../classes/models/rota/RotaAssignment';
import {RotaRoleAssignment} from '../../../../classes/models/rota/RotaRoleAssignment';
import {RotaAvailabilityAssignment} from '../../../../classes/models/rota/RotaAvailabilityAssignment';
import {Rota} from '../../../../classes/models/rota/Rota';
import {visibleRoles} from '../../../../classes/enums/RotaRole';
import {DayOfWeek} from '../../../../classes/enums/DayOfWeek';
import {EmployeePositionId} from '../../../../classes/models/employee/Employee';
import {SHARED_IMPORTS} from "../../../../shared/standalone-imports";

/**
 * This component displays availability or work assignments of an employee, on a weekly rota page.
 */
@Component({
  selector: 'app-rota-week-work-day',
  templateUrl: './rota-week-work-day.component.html',
  styleUrls: ['./rota-week-work-day.component.less'],
  imports: [SHARED_IMPORTS]
})
export class RotaWeekWorkDayComponent implements OnChanges {

  /** The date of a rota. */
  @Input() dayOfWeek: DayOfWeek;
  /** Identifiers of an employee and position. */
  @Input() employeePositionId: EmployeePositionId;
  /** Rota data for a week. */
  @Input() rota: Rota;

  /** An assignment to work in a shop for an employee. */
  rotaAssignment: RotaAssignment | undefined;
  /** Assignments with a specific role for an employee. */
  roleAssignments: RotaRoleAssignment[];
  /** An assignment when an employee is available. */
  availabilityAssignment: RotaAvailabilityAssignment | undefined;

  /**
   * Updates rota assignments on any input data change.
   */
  ngOnChanges(): void {
    this.rotaAssignment = this.rota.rotaAssignments
            .find(assignment => assignment.hasEqualEmployeeAndDay(this.employeePositionId, this.dayOfWeek));
    this.roleAssignments = this.rota.roleAssignments
            .filter(assignment => assignment.hasEqualEmployeeAndDay(this.employeePositionId, this.dayOfWeek))
            .filter(assignment => visibleRoles().some(role => role === assignment.role));
    this.availabilityAssignment = this.rota.availabilityAssignments
            .find(assignment => assignment.hasEqualEmployeeAndDay(this.employeePositionId, this.dayOfWeek));
  }
}
